import io from 'socket.io-client';
import { BACKEND_URL } from './utils/constants';

const socket = io(BACKEND_URL);
export default socket;
